"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sort = exports.numF = void 0;
const chalk = require("chalk");
const numF = (val) => chalk.bold.cyan(val.toString());
exports.numF = numF;
const sort = (a, b) => a.localeCompare(b);
exports.sort = sort;
